import '../embed/styles/base.css';
import { SimpleSearchWidget } from '../embed/pages/SimpleSearchWidget';
import { API_BASE } from '../lib/chatApi';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useStore } from '../context/StoreContext';

export default function SimpleSearch() {
  const [params] = useSearchParams();
  const initialQuery = params.get('q') || undefined;
  const navigate = useNavigate();
  const { storeId } = useStore();

  return (
    <div className="w-full h-screen">
      <SimpleSearchWidget
        storeId={storeId}
        apiBase={API_BASE}
        initialQuery={initialQuery}
        onRetry={() => navigate('/simple-search/entry')}
        onClose={() => navigate('/')}
        removePadding
      />
    </div>
  );
}
